// extracted by mini-css-extract-plugin
module.exports = {"container":"EABDApp_container__3BJfP","embeddedContainer":"EABDApp_embeddedContainer__Y-ASa"};